<template>
    <div>
        <div class="mini-card">
            <el-card>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <h2>{{ manufacturedOrder.name }}</h2>
                        <div class="info-identity">
                            <p><span>{{ $t('status') }}: </span><span class="data-display">{{ isRunningResult }}</span></p>
                            <p><span>{{ $t('start_date') }}: </span><span class="data-display">{{ getReadableFormat(manufacturedOrder.start) }}</span></p>
                            <p><span>{{ $t('end_date') }}: </span><span class="data-display">{{ getReadableFormat(manufacturedOrder.end) }}</span></p>
                            <p><span>{{ $t('duration') }}: </span><span class="data-display">{{ getElapsedTime(manufacturedOrder.start, manufacturedOrder.end) }}</span></p>
                            <p><span>{{ $t('total_time_recorded') }}: </span><span class="data-display">{{ getDurationFromMillis(manufacturedOrder.totalTime) }}</span></p>
                        </div>
                        <el-row>
                            <el-tooltip class="item" effect="dark" :content="$t('edit')" placement="top">
                                <el-button type="primary" icon="el-icon-edit" @click="editManufacturedOrder" circle></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="$t('duplicate')" placement="top">
                                <el-button type="primary" icon="el-icon-document-copy" @click="duplicateManufacturedOrder" circle></el-button>
                            </el-tooltip>
                            <!-- <el-tooltip class="item" effect="dark" :content="$t('details')" placement="top" v-if="isSuperAdmin">
                                <el-button type="primary" icon="el-icon-s-data" @click="getDetailsView" circle></el-button>
                            </el-tooltip> -->
                        </el-row>
                        <el-row v-if="manufacturedOrder.tags">
                            <p><span class="data-display">{{ $t('tag_list') }}: </span>{{ getTagsAsString(manufacturedOrder.tags) }}</p>
                            <p></p>
                        </el-row>
                    </el-col>
                    <el-col :span="9">
                        <div class="table-card">
                            <h3>{{ $t('production_area') }}</h3>
                            <el-table
                                :data="getProductionZoneAssociated"
                                size="small">
                                <el-table-column
                                    prop="name"
                                    :label="$t('production_area')">
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                    <!-- <el-col :span="9">
                        <div class="table-card">
                            <h3>{{ $t('last_controlled_operators') }}</h3>
                            <el-table
                            :data="tableData"
                            size="small">
                            <el-table-column
                                prop="ref"
                                label="Ref">
                            </el-table-column>
                            <el-table-column
                                prop="totalTime"
                                label="Tps tot.">
                            </el-table-column>
                            <el-table-column
                                prop="lastCheck"
                                label="Date ctrl.">
                            </el-table-column>
                            </el-table>
                        </div>
                    </el-col> -->
                </el-row>
            </el-card>
        </div>
        <!-- start Modal for Create OF form -->
        <el-dialog
            width="1200px"
            :visible.sync="dialogFormVisible"
            :modalAppendToBody="false">
            <CreateOf :formStateModal="ofFormType" :ofSelected="manufacturedOrder" :key="dialogFormVisible " @closeForm="closeForm"></CreateOf>
            </el-dialog>
        <!-- end Modal for Create OF form -->
    </div>
</template>

<script>
import CreateOf from '../components/of/CreateOf.vue'
import DateTimeManipulation from '../mixins/DateTimeManipulation'

export default {
    components: {
        CreateOf
    },
    props: {
        manufacturedOrder: {
            type: Object,
        }
    },
    data() {
        return {
            operation: {
                name: 'OFXXXXX01',
                totalTime: 127,
                status: 'En cours',
                cadenceGap: '-2 sec / p',
                TotalEstimedCost: 5648.21,
                start: '01/01/1970',
                end: '08/01/1970'
            },
            tableData: [{
                ref: 'ZXXXXXX3',
                totalTime: '5h56',
                lastCheck: '12/05/19'
            }, {
                ref: 'ZXXXXXX7',
                totalTime: '5h06',
                lastCheck: '14/04/19'
            }, {
                ref: 'ZXXXXXX9',
                totalTime: '23h12',
                lastCheck: '13/04/19'
            }, {
                ref: 'ZXXXXXX12',
                totalTime: '7h00',
                lastCheck: '13/04/19'
            }],
            ofFormType: 'edit',
            dialogFormVisible: false,
            isSuperAdmin: false,
        }
    },
    created () {
        this.isSuperAdmin = this.$store.getters.isSuperAdmin;
    },
    computed: {
        isRunningResult() {
            let now = new Date().getTime();
            if( now < this.manufacturedOrder.start ) {
                return 'A venir'
            } else if (now > this.manufacturedOrder.end) {
                return this.$t('ended')
            } else {
                return this.$t('running')
            }
        },
        getOfElapsedTime() {
            let dt = this.$store.getters.manufacturingOrderAssociated(this.productionZone.id);
            return this.getElapsedTime(dt.start, dt.end);
        },
        getProductionZoneAssociated () {
            return this.$store.getters.getProductionZoneNameAssociatedByOf(this.manufacturedOrder.productionZone)
        }
    },
    methods: {
        editManufacturedOrder: function() {
            this.ofFormType = 'edit';
            this.dialogFormVisible = true;
        },
        duplicateManufacturedOrder: function() {
            this.ofFormType = 'duplicate';
            this.dialogFormVisible = true;
        },
        getDetailsView: function() {
            this.$router.push({ name: 'manufacturing-order-details', params: { id: this.manufacturedOrder.id } })
        },
        closeForm: function() {
            this.dialogFormVisible = false;
            this.$emit('closeForm', false);
        },
        getTagsAsString(moTags) {
            if(!moTags) {
                return ''
            }
            return moTags.join(', ');
        },
        getDurationFromMillis(tsMillis) {
            const H = new Date(tsMillis - 3600000).getHours();
            const M = new Date(tsMillis - 3600000).getMinutes();
            return `${H < 10 ? '0' + H : H}H${M < 10 ? '0' + M : M}`;
        }
    },
    mixins: [DateTimeManipulation]
}
</script>

<style scoped>
    h3 {
        color: white;
    }

    .mini-card {
        margin-bottom: 20px;
    }

    .table-card {
        background-color: var(--color1light);
        padding: 10px;
        border-radius: 12px;
    }

    .info-identity {
        margin-bottom: 24px;

    }

    .info-identity > p {
        margin: 5px;
    }

    .data-display {
        font-weight: bold;
    }
</style>